function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { CSSProperties, FC, ReactElement } from 'react';
import cn from 'classnames';
require("./TableRow.css");
var styles = {
  "Root": "TableRow-module-Root_1_I"
};
export const TableRow = ({
  children,
  className,
  style,
  highlightColor = '#D1DBFF',
  highlighted = false,
  ...props
}) => {
  const finishStyle = {
    ...(style || {})
  };
  if (highlighted) {
    finishStyle.backgroundColor = highlightColor;
  }
  return /*#__PURE__*/React.createElement("tr", _extends({}, props, {
    className: cn(styles.Root, className),
    style: finishStyle
  }), children);
};